import { render, staticRenderFns } from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=template&id=77fca374&scoped=true"
import script from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=style&index=0&id=77fca374&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fca374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fca374')) {
      api.createRecord('77fca374', component.options)
    } else {
      api.reload('77fca374', component.options)
    }
    module.hot.accept("./QuoteBuilderLabourHeadingsComponent.vue?vue&type=template&id=77fca374&scoped=true", function () {
      api.rerender('77fca374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderLabour/QuoteBuilderLabourHeadingsComponent.vue"
export default component.exports